<div style="padding: 20px;">
    <fieldset class="block">
        <div class="form-group">
            <label>暱稱</label>
            <input type="text" class="form-control" [(ngModel)]="nickname" aria-describedby="emailHelp" placeholder="修改您的暱稱">
        </div>
        <div class="form-group">
            <label>電話</label>
            <input type="text" class="form-control" (keyup)="check_formate()"  [(ngModel)]="phone" aria-describedby="emailHelp" placeholder="修改您的電話">
            <small style="color:red" *ngIf="showphonemsg">請確認手機格式</small>
        </div>
        <button (click)="update_profile()" class="btn btn-primary update">修改</button>
    </fieldset>  
    <fieldset class="block">
        <div class="form-group">
            <label>舊密碼</label>
            <input type="password" class="form-control"  [(ngModel)]="oldpwd" aria-describedby="emailHelp" placeholder="請輸入您的舊密碼">
        </div>
        <div class="form-group">
            <label>新密碼</label>
            <input type="password" class="form-control" [(ngModel)]="newpwd" aria-describedby="emailHelp" placeholder="請輸入您的新密碼">
            <small style="color:red" *ngIf="newpwd!=repwd">請確認新密碼資料是否輸入一致</small>
        </div>
        <div class="form-group">
            <label>確認新密碼</label>
            <input type="password" class="form-control" [(ngModel)]="repwd" aria-describedby="emailHelp" placeholder="請再次輸入您的舊密碼">
            <small style="color:red" *ngIf="newpwd!=repwd">請確認新密碼資料是否輸入一致</small>
        </div>
        <button (click)="update_pwd()" class="btn btn-primary update">修改</button>
    </fieldset>
</div>


<div aria-live="polite" aria-atomic="true" style="right:0;min-height: 200px;width: 200px;margin-right: 10px;">
    <div role="alert" aria-live="assertive" aria-atomic="true" class="toast update" data-autohide="true"  data-delay="2000">
        <div class="toast-header">
            <strong class="mr-auto">{{toasts_itme.title}}</strong>
            <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="toast-body">
            {{toasts_itme.content}}            
        </div>
    </div>
</div>

<app-spinner [loading]="loading"></app-spinner>